/// <amd-module name="VSSUI/MasterDetails" />
export { DetailsPanel } from "./Components/DetailsPanel/DetailsPanel";
export { IDetailsPanelProps } from "./Components/DetailsPanel/DetailsPanel.Props";
export { MasterPanel, MasterPanelHeader } from "./Components/MasterPanel/MasterPanel";
export { IMasterPanelProps, IMasterPanelHeaderProps } from "./Components/MasterPanel/MasterPanel.Props";
export { SingleLayerMasterPanel, SingleLayerMasterPanelHeader } from "./Components/SingleLayerMasterPanel/SingleLayerMasterPanel";
export { ISingleLayerMasterPanelProps, ISingleLayerMasterPanelHeaderProps } from "./Components/SingleLayerMasterPanel/SingleLayerMasterPanel.Props";
